import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import HelperService from '../Services/HelperService';
import { TerminationFormInputsStep1, TerminationFormInputsStep2, TerminationFormStateActions, TerminationFormState as TerminationFormStateType, FullTerminationForm } from '../Types/Termination';

let prefilledDefaultTerminationFormState = {
    step1: {
        termination: 'Umzug ins Heim',
        terminationType: '0',
        terminationDate: '',
        terminationText: '',
        salutation: '',
        email: 'demo@demo.de',
        emailCopy: 'demo@demo.de',
        phone: '123456',
        firstName: 'Stefan',
        lastName: 'Sonnenschein',
        street: 'Musterstraße',
        houseNumber: '12a',
        zip: '44319',
        city: 'Dortmund',
        birthdate: '1990-12-12',
        contractAddress: '0',
        contractSalutation: '',
        contractFirstName: 'Martin',
        contractLastName: 'Musterfrau',
        contractStreet: 'Demostraße',
        contractHouseNumber: '2b',
        contractZip: '12345',
        contractCity: 'Musterhausen',
    },
    step2: {
        token: '',
        time: null,
    },
};

export const defaultTerminationFormState = {
    step1: {
        termination: '',
        terminationType: '0',
        terminationDate: '',
        terminationText: '',
        salutation: '',
        email: '',
        emailCopy: '',
        phone: '',
        firstName: '',
        lastName: '',
        street: '',
        houseNumber: '',
        zip: '',
        city: '',
        birthdate: '',
        contractAddress: '0',
        contractSalutation: '',
        contractFirstName: undefined,
        contractLastName: undefined,
        contractStreet: undefined,
        contractHouseNumber: undefined,
        contractZip: undefined,
        contractCity: undefined,
    },
    step2: {
        token: '',
        time: null,
    },
};

// function that sets pre filled fields for termination form in dev mode
const getDefaultTerminationFormFields = () => {
    if (HelperService.isDevelopment) {
        return prefilledDefaultTerminationFormState as TerminationFormStateType;
    }
    return defaultTerminationFormState;
};
export const useTerminationFormState = create<TerminationFormStateType & TerminationFormStateActions>()(
    immer(
        devtools(
            (set, get) => ({
                ...getDefaultTerminationFormFields(),
                setStep1: (step1Form: TerminationFormInputsStep1) =>
                    set(
                        (state) => {
                            state.step1 = step1Form;
                        },
                        false,
                        { type: 'setStep1' }
                    ),
                setStep2: (step2Form: TerminationFormInputsStep2) =>
                    set(
                        (state) => {
                            state.step2 = step2Form;
                        },
                        false,
                        { type: 'setStep1' }
                    ),
                fullFormState: () => {
                    return { ...get().step1, ...get().step2 } as FullTerminationForm;
                },
                resetTerminationForm: () =>
                    set(
                        (state) => {
                            state.step1 = defaultTerminationFormState.step1;
                        },
                        false,
                        { type: 'resetTerminationForm' }
                    ),
            }),
            { name: 'TerminationFormState', enabled: HelperService.isDevelopment }
        )
    )
);
